
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ParameterContent from "./Components/ParameterContent.vue";

export default defineComponent({
  name: "JourneysPage",
  components: {
    BreadCrumb,
    ParameterContent,
  },
});
